import { z } from "zod";

// Экран «Сборки»: выбранный герой в search params — `/builds?hero=1`. Нет или неверный —
// герой по умолчанию (самый частый у игрока).
export const heroBuildsSearchSchema = z.object({
  hero: z.number().int().positive().optional().catch(undefined),
});

export type HeroBuildsSearch = z.infer<typeof heroBuildsSearchSchema>;
